import { Link } from 'react-router-dom';
// import ImageContainer from '../../components/ui/ImageContainer';
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { getLocaleString } from '../../utils/locales';
import GoldConvenience from './goldConvenience';

const OurMembership = () => {
  const locale = getData(LANGUAGE);
  return (
    <div className="">
      <div className="flex items-center justify-center w-full">
        <div>
          <div>
            {/* <p className="pt-16 text-center text-xl lg:text-3xl font-bold text-[#010103]/80 lg:pt-12 lg:pb-4">
              {getLocaleString('our_memberships', locale)}
            </p> */}
            {/* <div className="flex items-center justify-center w-full mt-10">
              <div className="space-x-0 space-y-8 md:flex md:space-x-4 md:space-y-0">
                
                <ImageContainer src="/image/membership/Our Membership-Logo-2.jpg" alt="basis" className="h-[70px] lg:h-[220px]" />
              </div>
            </div> */}
          </div>
          <div className="flex items-center justify-center w-full px-8 pt-10 lg:px-0 lg:pt-14">
            <p className="text-4xl font-semibold capitalize text-[#010103]/80 md:text-6xl">
             {getLocaleString('why_gold_kinen_home', locale)}
            </p>
          </div>

          <div className="flex items-center justify-center px-8 pt-10 md:px-24">
            <div className="space-y-6 lg:flex lg:space-x-10 lg:space-y-0">
              <div className="w-full py-4 space-y-4 bg-white shadow-lg rounded-2xl lg:max-w-xs">
                <p className="py-6 text-2xl font-semibold text-center text-white rounded-t-lg bg-primary">
                  {getLocaleString('easy', locale)}
                </p>
                <p className="p-6 text-xl font-light text-[#2C2C2C] text-justify">
                  {getLocaleString('easy_description', locale)}
                </p>
              </div>

              <div className="w-full py-4 space-y-4 bg-white shadow-lg rounded-2xl lg:max-w-xs">
                <p className="py-6 text-2xl font-semibold text-center text-white rounded-t-lg bg-gradient-to-r from-[#e9be5a] to-[#c6952c] focus:outline-none">
                  {getLocaleString('safe', locale)}
                </p>
                <p className="p-6 py-4 text-xl font-light text-[#2C2C2C] text-justify">
                  {getLocaleString('safe_description', locale)}

                </p>
              </div>
              <div className="w-full py-4 space-y-4 bg-white shadow-lg rounded-2xl lg:max-w-xs">
                <p className="py-6 text-2xl font-semibold text-center text-white rounded-t-lg bg-primary">
                  {getLocaleString('trusted', locale)}
                </p>
                <p className="p-6 py-4 text-xl font-light text-[#2C2C2C] text-justify">
                 {getLocaleString('trusted_description', locale)}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center pt-12">
            <Link
              to={`/${locale}/gold-kinen`}
              className="py-4 text-base font-semibold text-primary rounded-lg bg-gradient-to-r from-[#e9be5a] to-[#c6952c] hover:bg-gradient-to-br focus:outline-none px-14 hover:text-white"
            >
              {getLocaleString('learn_more', locale)}
            </Link>
          </div>
        </div>
      </div>
      <GoldConvenience />
    </div>
  );
};

export default OurMembership;
